import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'execute-workflow',
  name: 'Workflow Trigger',
  category: 'triggers',
  description: 'Triggered when a parent workflow executes this workflow as a sub-workflow',
  icon: 'Workflow',
  color: 'purple',
  version: '1.1.0',
  
  group: ['trigger'],
  
  defaults: {
    name: 'Workflow Trigger',
    color: '#9333ea'
  },
  
  subtitle: 'Receives data from parent workflow',
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['workflow', 'trigger', 'subworkflow', 'nested', 'child'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'Trigger node for workflows executed by Execute Workflow nodes in parent workflows'
  }
};

export default definition;
